export class LoadCurrentClient {
  static readonly type = '[CurrentClient] Load Current Client';
}
